"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatErrorMessage = exports.siAuthHandlerFactory = void 0;
const uuid_1 = require("uuid");
const auth_1 = require("firebase/auth");
const util_1 = require("@firebase/util");
const siAuthHandlerFactory = (functionOrigin, drecomSignInPageUrl, drecomTarget, auth, toost, navigate) => () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const generatedState = (0, uuid_1.v4)();
        // TODO: Dedupe Multiple Clicks
        const { token, selectedProjectId } = yield new Promise((resolve, reject) => {
            const listener = (e) => {
                if (e.origin !== functionOrigin)
                    return;
                try {
                    const parsed = JSON.parse(e.data);
                    if ((parsed === null || parsed === void 0 ? void 0 : parsed.type) === "token") {
                        window.removeEventListener("message", listener);
                        const state = parsed === null || parsed === void 0 ? void 0 : parsed.state;
                        if (typeof state !== "string" || state !== generatedState) {
                            reject(new Error("認証に失敗しました (詳細: Invalid State)。再度認証をお試しください。もしエラーが復旧しない場合、サポートにお問い合わせください。"));
                        }
                        const token = parsed === null || parsed === void 0 ? void 0 : parsed.token;
                        if (typeof token === "string") {
                            resolve(Object.assign({ token }, ((parsed === null || parsed === void 0 ? void 0 : parsed.selectedProjectId) && {
                                selectedProjectId: parsed === null || parsed === void 0 ? void 0 : parsed.selectedProjectId,
                            })));
                            return;
                        }
                    }
                }
                catch (e) {
                    console.log(e);
                }
            };
            window.addEventListener("message", listener);
            const signInPageUrl = new URL(drecomSignInPageUrl);
            signInPageUrl.searchParams.set("state", generatedState);
            const child = window.open(signInPageUrl.toString(), drecomTarget, "menubar=no");
            if (!child)
                return;
        });
        yield (0, auth_1.signInWithCustomToken)(auth, token);
        if (selectedProjectId && navigate) {
            navigate(`/admin/projects/${selectedProjectId}/segments/list`);
        }
    }
    catch (e) {
        console.dir(e, { depth: 120 });
        toost({
            message: (0, exports.formatErrorMessage)(e),
            duration: 10000,
        });
    }
});
exports.siAuthHandlerFactory = siAuthHandlerFactory;
const errorMessages = {
    "auth/email-already-exists": "提供されたメールアドレスはすでに既存のユーザーによって使用されています。",
    "auth/invalid-email": "emailが無効です。",
    "auth/invalid-password": "パスワードは少なくとも 6 文字である必要があります。",
    "auth/account-exists-with-different-credential": "このメールアドレスはすでに他のログイン方法で使用されるため、このログイン方法ではログインできません。",
    "auth/user-not-found": "メールアドレスまたはパスワードが違います",
    "auth/wrong-password": "メールアドレスまたはパスワードが違います",
    "auth/invalid-action-code": "メールからのリンクが無効です。再度、メール認証を行ってください。",
    "auth/missing-password": "パスワードが入力されていません。",
    "auth/weak-password": "パスワードが短すぎます。6文字以上で指定してください。",
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const formatErrorMessage = (e) => {
    console.log(e);
    if (e instanceof util_1.FirebaseError && e.code && errorMessages[e.code]) {
        return errorMessages[e.code];
    }
    else if (e instanceof Error) {
        return e.message;
    }
    else {
        return "";
    }
};
exports.formatErrorMessage = formatErrorMessage;
